var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUrlPaste(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1111 0H5.77778C4.18889 0 2.88889 1.3 2.88889 2.88889C1.3 2.88889 0 4.18889 0 5.77778V10.1111C0 11.7 1.3 13 2.88889 13H7.22222C8.81111 13 10.1111 11.7 10.1111 10.1111C11.7 10.1111 13 8.81111 13 7.22222V2.88889C13 1.3 11.7 0 10.1111 0ZM8.66667 10.1111C8.66667 10.9056 8.01667 11.5556 7.22222 11.5556H2.88889C2.09444 11.5556 1.44444 10.9056 1.44444 10.1111V5.77778C1.44444 4.98333 2.09444 4.33333 2.88889 4.33333H7.22222C8.01667 4.33333 8.66667 4.98333 8.66667 5.77778V10.1111ZM11.5556 7.22222C11.5556 8.01667 10.9056 8.66667 10.1111 8.66667V5.77778C10.1111 4.18889 8.81111 2.88889 7.22222 2.88889H4.33333C4.33333 2.09444 4.98333 1.44444 5.77778 1.44444H10.1111C10.9056 1.44444 11.5556 2.09444 11.5556 2.88889V7.22222Z",
    fill: "url(#paint0_linear_5728_68735)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5728_68735",
    x1: 0.859572,
    y1: 14.3977,
    x2: 15.3614,
    y2: 8.92644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUrlPaste);
export default __webpack_public_path__ + "static/media/url-paste.b2933049b55a455345c6d2ff1a31b96c.svg";
export { ForwardRef as ReactComponent };